<script setup>
import { useChecklist } from '@/composables/useChecklist'
import { useRoute, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'template-manage',
    subject: 'Checklist',
  },
})

const route = useRoute('checklist-templates-id-edit')
const router = useRouter()
const { template, saving, fetchTemplate, updateTemplate } = useChecklist()

onMounted(() => fetchTemplate(route.params.id))

const form = ref({ checklist_category_id: null, name: '', description: '', is_active: true })
const errors = ref({})

watch(template, t => {
  if (!t) return
  form.value = {
    checklist_category_id: t.checklist_category_id,
    name: t.name,
    description: t.description ?? '',
    is_active: t.is_active,
  }
}, { immediate: true })

const save = async () => {
  errors.value = {}
  try {
    await updateTemplate(route.params.id, form.value)
    router.push({ name: 'checklist-templates' })
  } catch (e) {
    if (e?.status === 422) errors.value = e?.data?.errors ?? {}
    else console.error('Update checklist template error:', e)
  }
}
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Edit Template Checklist
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Item checklist tidak bisa diubah di sini — sudah dipakai riwayat hasil pengisian (BR-005)
    </p>

    <VCard max-width="640">
      <VCardText class="pa-6">
        <VRow>
          <VCol cols="12">
            <MasterDataPicker
              v-model="form.checklist_category_id"
              entity="checklist-categories"
              label="Kategori Checklist *"
              :error-messages="errors.checklist_category_id"
            />
          </VCol>
          <VCol cols="12">
            <VTextField
              v-model="form.name"
              label="Nama Template *"
              :error-messages="errors.name"
            />
          </VCol>
          <VCol cols="12">
            <VTextarea
              v-model="form.description"
              label="Deskripsi"
              rows="2"
              :error-messages="errors.description"
            />
          </VCol>
          <VCol cols="12">
            <VSwitch
              v-model="form.is_active"
              label="Aktif"
              color="success"
              hide-details
            />
          </VCol>
          <VCol
            v-if="template?.items?.length"
            cols="12"
          >
            <p class="text-body-2 font-weight-medium mb-2">
              Item Checklist ({{ template.items.length }}) — read-only
            </p>
            <VList
              density="compact"
              class="border rounded"
            >
              <VListItem
                v-for="item in template.items"
                :key="item.id"
                :title="item.label"
                :subtitle="item.answer_type"
              />
            </VList>
          </VCol>
        </VRow>
      </VCardText>
      <VCardActions class="pa-6 pt-0">
        <VSpacer />
        <VBtn
          variant="tonal"
          color="secondary"
          :disabled="saving"
          @click="router.push({ name: 'checklist-templates' })"
        >
          Batal
        </VBtn>
        <VBtn
          color="primary"
          :loading="saving"
          @click="save"
        >
          Simpan
        </VBtn>
      </VCardActions>
    </VCard>
  </div>
</template>
